<template>
  <div class="body container">
    <div class="wrap clearfix">
      <div class="video-container fl">
        <div class="rotation_top">
          <div class="block">
            <!-- <span class="demonstration">轮播图1</span> -->
            <h1>
              <i></i>
              <span>学校风采</span>
            </h1>
            <el-carousel height="242px" arrow="always" v-if="windowArticle.length != 0">
              <el-carousel-item v-for="item in this.windowArticle" :key="item.id">
                <!-- 跳转自定义栏目 -->
                <img :src="item.coverImg" :onerror="errorImg" width="100%" height="100%" style="cursor: pointer"
                  @click="toInfoPage(item)" />
              </el-carousel-item>
            </el-carousel>

            <el-carousel height="260px" arrow="always" v-if="windowArticle.length == 0 && isLoad">
              <img src="../../assets/img/fengcai_default.png" @click="toInfoDefaultPage()" width="100%" height="99%" />
            </el-carousel>
          </div>
        </div>
      </div>
      <div class="news-wrapper fl" style="margin: 0 30px">
        <h1>
          <i class="icon-news"></i>
          <span class="title">新闻动态</span>
          <a class="more" @click="jumpToMore('ArticleList', 2, 201)" style="cursor: pointer">
            <span>更多</span>
            <em></em>
          </a>
        </h1>
        <ul class="news-item" v-if="columnArticleNew.length">
          <li v-for="article in columnArticleNew" :key="article.id">
            <a @click="jumpToInfo2(2, 'articleInfo', '?articleid=' + article.id,article)" style="cursor: pointer"
              :title="article.title">{{ article.title }}</a>
            <span>{{ article.create_time.substr(0, 10) }}</span>
          </li>
        </ul>
        <div class="none-info-1" v-if="none1">
          <img src="../../assets/img/home_img_1.png" />
          <br />
          <span>暂无新闻动态</span>
        </div>
      </div>
      <div class="news-wrapper fl">
        <h1>
          <i class="icon-notice"></i>
          <span class="title">文件公告</span>
          <a class="more" @click="jumpToMore('ArticleList', 2, 202)" style="cursor: pointer">
            <span>更多</span>
            <em></em>
          </a>
        </h1>
        <ul class="news-item" v-if="columnArticleFile.length">
          <li v-for="article in columnArticleFile" :key="article.id">
            <a @click="jumpToInfo(2, 'articleInfo', '?articleid=' + article.id)" style="cursor: pointer"
              :title="article.title">{{ article.title }}</a>
            <span>{{ article.create_time.substr(0, 10) }}</span>
          </li>
        </ul>
        <div class="none-info-1" v-if="none2">
          <img src="../../assets/img/home_img_1.png" />
          <br />
          <span>暂无文件公告</span>
        </div>
      </div>
    </div>

    <div class="wrap">
      <ul class="icon-wrapper icon-wrapperrr clearfix">
        <li v-for="item in ModuleLinks" :key="item.position">
          <div>
            <a class="icon-hook" target="_blank" :href="item.url" :title="item.title">
              <img :src="item.image_fileid" :onerror="errorImg" />
            </a>
          </div>
          <p>
            <a class="icon-hook" target="_blank" :href="item.url">{{
              item.title
            }}</a>
          </p>
        </li>
      </ul>
    </div>

    <!-- 快捷菜单 -->
    <!-- <div class="fast">
      <p class="fast-p1">
        <img src="../../assets/img/fatExpress.png" alt />
      </p>
      <p class="fast-p2" v-for="item in ModuleLinks" :key="item.position" v-if="item.title">
        <a target="_blank" :href="item.url">
          <img :src="item.image_fileid" />
        </a>
        <a target="_blank" :href="item.url" class="fast-title" :title="item.title">{{item.title}}</a>
      </p>
    </div>-->
    <!-- 快捷菜单END -->

    <div class="wrap" style="margin: 40px 0 20px 0">
      <div class="top" style="border: none">
        <div class="title">
          <i class="icon-group"></i>
          <span>专题工作</span>
        </div>
        <div class="top-nav" id="grouproom">
          <el-tabs v-model="activeName1" @tab-click="handleClick1">
            <el-tab-pane :stretch="true" label="全部" name="0"></el-tab-pane>
            <el-tab-pane :stretch="true" :label="navItem.name" :name="navItem.id.toString()"
              v-for="navItem in groupType" :key="navItem.id"></el-tab-pane>
          </el-tabs>

          <!-- <a
            :class="groupTypeId == 0?'active':''"
            @click="selectGroup(0)"
            style="cursor:pointer;"
          >全部</a>
          <a
            v-for="navItem in  groupType"
            @click="selectGroup(navItem.id)"
            :key="navItem.id"
            :class="groupTypeId == navItem.id?'active':''"
            style="cursor:pointer;"
          >{{navItem.name}}</a>-->
        </div>

        <a class="more" @click="jumpToMore('school_activity_group', 2, 701)" style="cursor: pointer">
          <span>更多</span>
          <em></em>
        </a>
      </div>
      <ul class="group clearfix" id="grouplist" v-if="groupList.length">
        <li class="group-item" v-for="item in groupList" :key="item.id">
          <a class="cover" href="javascript:;" @click="jumpToInfo(3, 'index', 'groupid=' + item.id)"
            style="cursor: pointer" :title="item.name">
            <img class="group_cover" src="../../assets/img/xzz_default1.png" :onerror="errorImg"
              v-if="item.logo_resid == ''" />
            <img class="group_cover" :src="item.logo" :onerror="errorxzzImg" v-else />
          </a>
          <div class="group-info">
            <a class="title" @click="jumpToInfo(3, 'index', 'groupid=' + item.id)" style="cursor: pointer"
              :title="item.name">{{ item.name }}</a>
            <div class="info" style="margin: 10px 0">
              <span>组长: {{ item.username }}</span>
              <span>成员: {{ item.member_count }}</span>
            </div>
            <p class="type">类型: {{ item.group_type }}</p>
            <div class="info">
              <span>视频: {{ item.video_count }}</span>
              <span>文章: {{ item.article_count }}</span>
            </div>
          </div>
        </li>
      </ul>
      <div class="none-info" v-if="none3">
        <img src="../../assets/img/home_img_2.png" />
        <br />
        <span>暂无专题工作</span>
      </div>
    </div>

    <div class="wrap" style="margin: 40px 0 20px 0">
      <div class="top" style="border: none">
        <div class="title">
          <i class="icon-group"></i>
          <span>师生展评</span>
        </div>

        <a class="more" @click="jumpToMore('school_activity_zhaning', 2, 704)" style="cursor: pointer">
          <span>更多</span>
          <em></em>
        </a>
      </div>
      <ul class="group clearfix" id="grouplist" v-if="schoolPresentation.length">
        <li class="group-item" v-for="item in schoolPresentation" :key="item.id">
          <a class="cover" @click="
              jumpToInfo(
                4,
                'presentation_info',
                'a_id=' + item.activity_id
              )
            " style="cursor: pointer" :title="item.title">
            <img class="group_cover" :src="item.logo" :onerror="errorZpImg" />
          </a>
          <div class="group-info">
            <a class="title" @click="
                jumpToInfo(
                  4,
                  'presentation_info',
                  'a_id=' + item.activity_id
                )
              " style="cursor: pointer" :title="item.title">{{ item.title }}</a>
            <div class="info" style="margin: 10px 0">
              <span>{{ item.active_type }}</span>
              <span>浏览:{{ item.view_count }}</span>
            </div>
            <p class="type">
              参赛人员：{{ item.contestant_identity == 1 ? "学生" : "教师"
              }}
              <!-- {{ item.participant_count }}人 -->
            </p>
            <div class="info">
              <span>{{ item.begin_time.substr(0, 10) }}—{{
                  item.end_time.substr(0, 10)
                }}</span>
            </div>
          </div>
        </li>
      </ul>
      <div class="none-info" v-if="none4">
        <img src="../../assets/img/home_img_2.png" />
        <br />
        <span>暂无师生展评</span>
      </div>
    </div>

    <el-carousel indicator-position="outside" v-if="TeachingActivity.length != 0">
      <el-carousel-item v-for="item in TeachingActivity" :key="item.id">
        <div class="pkhd" @click="jumpPath(item.type, item.id)">
          <img src="../../assets/img/pkhd-fm.jpg" />
          <p class="title">{{ item.title }}</p>
          <p class="time">
            活动时间：{{ item.begin_time.substr(0, 10) }} ~
            {{ item.end_time.substr(0, 10) }}
          </p>
        </div>
      </el-carousel-item>
    </el-carousel>

    <div class="wrap">
      <div class="top" style="border: none">
        <div class="title">
          <i class="icon-sync"></i>

          <span>微课</span>
        </div>
        <a class="more" @click="jumpToMore('school_video_weike', 2, 401)" style="cursor: pointer">
          <span>更多</span>
          <em></em>
        </a>
      </div>
      <ul class="video clearfix" id="video" v-if="schoolWeike.length">
        <li class="videoList marginBottom" v-for="item in schoolWeike" :key="item.id">
          <a class="cover" @click="
              jumpToInfo1(
                2,
                'school_video_info',
                'id=' + item.id + '&video_type=1',
                item.permission_scope
              )
            " style="cursor: pointer" :title="item.title">
            <img :src="item.coverImg" :onerror="errorImg" />
            <div class="coverTitle" style="display: none; cursor: pointer">
              {{ item.title }}
            </div>
          </a>
          <div class="videoInfo">
            <a class="title" @click="
                jumpToInfo1(
                  2,
                  'school_video_info',
                  'id=' + item.id + '&video_type=1',
                  item.permission_scope
                )
              " style="cursor: pointer" :title="item.title">{{ item.title }}</a>
            <div>
              <span class="username">
                <i></i>
                <em>{{ item.username }}</em>
              </span>
              <span class="num">
                <i></i>
                <em>{{ item.user_browse_count }}</em>
              </span>
            </div>
          </div>
        </li>
      </ul>
      <div class="none-info" v-if="none5">
        <img src="../../assets/img/home_img_2.png" />
        <br />
        <span>暂无微课视频</span>
      </div>
    </div>
    <div class="wrap" v-if="isActive">
      <div class="top" style="border: none">
        <div class="title">
          <i class="icon-sync"></i>
          <span @click="isActive = true" style="cursor: pointer">课堂实录</span>
          &nbsp; &nbsp;
          <span class="thisActive" style="cursor: pointer" @click="isActive = false">直播课堂</span>
        </div>
        <a class="more" href="javascript:;" @click="jumpToMore('school_video_class', 2, 402)" style="cursor: pointer">
          <span>更多</span>
          <em></em>
        </a>
      </div>

      <ul class="video clearfix" id="video" v-if="CourseVideo.length">
        <li class="videoList marginBottom" v-for="item in CourseVideo" :key="item.id">
          <a class="cover" @click="
              jumpToInfo1(
                2,
                'school_video_info',
                'id=' + item.id + '&video_type=2',
                item.permission_scope
              )
            " style="cursor: pointer" :title="item.title">
            <img :src="item.coverImg" :onerror="errorImg" />
            <div class="coverTitle" style="display: none">{{ item.title }}</div>
          </a>
          <div class="videoInfo">
            <a class="title" @click="
                jumpToInfo1(
                  2,
                  'school_video_info',
                  'id=' + item.id + '&video_type=2',
                  item.permission_scope
                )
              " style="cursor: pointer" :title="item.title">{{ item.title }}</a>
            <div>
              <span class="username">
                <i></i>
                <em>{{ item.username }}</em>
              </span>
              <span class="num">
                <i></i>
                <em>{{ item.user_browse_count }}</em>
              </span>
            </div>
          </div>
        </li>
      </ul>
      <div class="none-info" v-if="none6">
        <img src="../../assets/img/home_img_2.png" />
        <br />
        <span>暂无实录视频</span>
      </div>
    </div>
    <div class="wrap" v-if="!isActive">
      <div class="top" style="border: none">
        <div class="title">
          <i class="icon-live"></i>
          <span class="thisActive" style="cursor: pointer" @click="isActive = true">课堂实录</span>
          &nbsp; &nbsp;
          <span @click="isActive = false" style="cursor: pointer">直播课堂</span>
        </div>

        <a class="more" @click="jumpToMore('school_webcast_class', 2, 801)" style="cursor: pointer">
          <span>更多</span>
          <em></em>
        </a>
      </div>
      <ul class="video clearfix" v-if="Webcast.length">
        <li class="videoList" v-for="item in Webcast" :key="item.id">
          <a class="cover" @click="
              jumpToInfo1(
                2,
                'school_webcast_class_info',
                'id=' + item.id,
                item.permission_scope
              )
            " style="cursor: pointer" :title="item.title">
            <img :src="item.coverImg" :onerror="errorCastImg" />
            <div class="coverTitle">{{ item.cn_status }}</div>
          </a>
          <div class="videoInfo">
            <a class="title" @click="
                jumpToInfo1(
                  2,
                  'school_webcast_class_info',
                  'id=' + item.id,
                  item.permission_scope
                )
              " style="cursor: pointer" :title="item.title">{{ item.title }}</a>
            <div>
              <span class="username">
                <i></i>
                <em>{{ item.username }}</em>
              </span>
              <span class="num">
                <i></i>
                <em>{{ item.view_count }}</em>
              </span>
            </div>
          </div>
        </li>
      </ul>
      <div class="none-info" v-if="none7">
        <img src="../../assets/img/home_img_2.png" />
        <br />
        <span>暂无直播视频</span>
      </div>
    </div>
    <div>
      <el-row :gutter="20" style="margin-top:50px">
        <el-col :span="6" @click="goto(1)">
          <span style="font-weight:bold;position: relative;top: -15px;color:#858585;cursor:pointer"
            @click="goto(1)">学校精品备课</span>
          <div class="grid-content bg-purple" @click="goto(1)"><img src="../../common/imgs/文章资源.jpg"
              style="width:300px;height:200px;cursor:pointer" />
          </div>
        </el-col>
        <el-col :span="6" style="margin-left:50px" @click="goto(2)">
          <span style="font-weight:bold;position: relative;top: -15px;color:#858585;cursor:pointer"
            @click="goto(2)">学校精品课堂</span>
          <div class="grid-content bg-purple" @click="goto(2)"><img src="../../common/imgs/视频精品.jpg"
              style="width:300px;height:200px;cursor:pointer" />
          </div>
        </el-col>
        <el-col :span="6" style="margin-left:50px">
          <span style="font-weight:bold;position: relative;top: -15px;color:#858585;cursor:pointer"
            @click="goto(3)">同步题库资源</span>
          <div class="grid-content bg-purple" @click="goto(3)"><img src="../../common/imgs/111.jpg"
              style="width:300px;height:200px;cursor:pointer" />
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- <div class="wrap">
      <div class="top" style="border: none">
        <div class="title">
          <i class="icon-live"></i>
          <span @click="isActive = true">同步题库资源</span>
        </div>
        <div class="top-nav" id="grouproom" v-if="sectionList.length != 1">
          <a
            @click="selectSection(item.section_id)"
            v-for="item in sectionList"
            :key="item.section_id"
            :class="sectionId == item.section_id ? 'active' : ''"
            style="cursor: pointer"
            >{{ item.section_name }}</a
          >
        </div>
      </div>
      <ul class="icon-wrapper icon-wrapper1 clearfix">
        <li v-for="item in subjectList" :key="item.position">
          <div class="clearfixImg">
            <a class="icon-hook" :href="item.tikuUrl" target="_blank">
              <img :src="item.imgUrl" :onerror="errorImg" />
            </a>
          </div>
        </li>
      </ul>
    </div> -->

    <div class="wrap resource-wrapper">
      <div class="top teaching_resource">
        <div class="title" style="float: left; position: relative">
          <i class="icon-resource"></i>
          <span>教学资源</span>
        </div>

        <div>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane :stretch="true" label="全部" name="0"></el-tab-pane>
            <el-tab-pane :stretch="true" :label="item.name" :name="item.id.toString()" v-for="item in ArticleType"
              :key="item.id"></el-tab-pane>
          </el-tabs>
          <!-- <a
            href="javascript:"
            :class="item.id==ArticleId?'active':''"
            @click="changeArticleType(item.id)"
          >{{item.name}}</a>-->
        </div>
        <a class="more" @click="jumpToMore('school_article_teaching', 2, 502)" style="
            cursor: pointer;
            position: absolute;
            right: 0;
            margin-top: -47px;
          ">
          <span>更多</span>
          <em></em>
        </a>
      </div>
      <ul class="news-item clearfix" id="source" style="min-height: 240px" v-if="ArticleList.length">
        <li v-for="item in ArticleList" :key="item.id">
          <a href="javascript:;" @click="
              jumpToInfo1(
                2,
                'school_activity_view',
                'act_id=' + item.id,
                item.permission_scope
              )
            " style="cursor: pointer; width: 450px" :title="item.title">{{ item.title }}</a>
          <span>{{ item.create_time.substr(0, 10) }}</span>
        </li>
      </ul>
      <div class="none-info" v-if="none8">
        <img src="../../assets/img/home_img_2.png" />
        <br />
        <span>暂无教学资源</span>
      </div>
    </div>

    <!-- 班级空间模块 -->
    <div class="wrap">
      <div class="top" style="border: none">
        <div class="title">
          <i class="icon-sync"></i>

          <span>班级空间</span>
        </div>
        <a class="more" @click="jumpToMore('school_space_class', 2, 901)" style="cursor: pointer">
          <span>更多</span>
          <em></em>
        </a>
      </div>
      <ul class="video clearfix">
        <li class="videoList" v-for="item in classData" :key="item.classid">
          <a class="cover" href="JavaScript:;" @click="toClassSpace(item)">
            <!-- <img src="../../assets/img/banji.png" /> -->
            <img :src="item.logo" :onerror="defaultClassImg" />
          </a>
          <div class="videoInfo classL">
            <a target="_blank" class="title" href="JavaScript:;"
              @click="toClassSpace(item)">{{ item.cn_grade }}{{ item.class_no }}班</a>
          </div>
        </li>
      </ul>
      <div class="none-info" v-if="nodata">
        <img src="../../assets/img/home_img_2.png" />
        <br />
        <span>暂无班级</span>
      </div>
    </div>

    <!-- 教师空间模块 -->
    <div class="wrap">
      <div class="top" style="border: none">
        <div class="title">
          <i class="icon-sync"></i>

          <span>教师空间</span>
        </div>
        <a class="more" @click="jumpToMore('school_space_tch_stu', 2, 902)" style="cursor: pointer">
          <span>更多</span>
          <em></em>
        </a>
      </div>
      <ul class="teachList clearfix">
        <li class="tlst" v-for="item in teacherList" :key="item.userid" @click="toSpace(item)" style="cursor: pointer">
          <img :src="item.face_url" alt :onerror="errorImg" />
          <p>{{ item.username }}</p>
        </li>
      </ul>
      <div class="none-info" v-if="none9">
        <img src="../../assets/img/home_img_2.png" />
        <br />
        <span>暂无教师</span>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="jumpVisable" width="30%" style="color:red">
      <span>即将跳转：{{link}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="jumpVisable = false">取 消</el-button>
        <el-button type="primary" @click="goActicleInfo()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import globalApi from "@/common/globalApi.js";
import { log } from "util";
export default {
  name: "index",
  data() {
    return {
      errorCastImg:
        'this.src="' + require("../../assets/img/onliveDf.png") + '"', // 图片损坏默认图
      errorImg: 'this.src="' + require("../../assets/img/damage.png") + '"', // 图片损坏默认图
      errorZpImg:
        'this.src="' + require("../../assets/img/zhangpinDf.png") + '"', // 展评
      errorxzzImg:
        'this.src="' + require("../../assets/img/xzz_default1.png") + '"', // 专题工作
      articleData: [],
      schoolid: 0,
      isActive: true, //  课堂实录/直播课堂切换
      groupType: [], // 专题工作类型
      groupTypeId: 0, // 专题工作类型ID
      groupList: [], // 专题工作列表
      windowArticle: [], // 校园视窗
      coverImg: "", // 校园视窗封面
      columnArticleFile: [], // 文件公告
      schoolPresentation: [], // 师生展评
      schoolWeike: [], // 微课
      CourseVideo: [], // 课堂实录
      Webcast: [], // 直播课堂
      teacherList: [], // 教师列表
      ClassList: [], // 班级列表
      ArticleType: [], // 教学资源类型
      ArticleList: [], // 教学资源列表
      ArticleId: 201, // 教学资源列表
      ModuleLinks: [], // 快捷链接
      columnArticleNew: [], // 新闻动态
      sectionList: [], // 学段列表
      sectionId: 0, // 学段
      subjectList: [], // 科目
      TeachingActivity: [], // 热门活动
      subjectId: 0,
      activeName: "201",
      activeName1: "0",
      isLoad: false,
      imgUrl: [
        {
          src: "",
        },
        {
          src: "/static/img/icon_class_language@2x.png",
        },
        {
          src: "/static/img/icon_class_mathematics@2x.png",
        },
        {
          src: "/static/img/icon_class_English@2x.png",
        },
        {
          src: "/static/img/icon_class_history@2x.png",
        },
        {
          src: "/static/img/icon_class_geography@2x.png",
        },
        {
          src: "/static/img/icon_class_politics@2x.png",
        },
        {
          src: "/static/img/icon_class_biology@2x.png",
        },
        {
          src: "/static/img/icon_class_physics@2x.png",
        },
        {
          src: "/static/img/icon_class_chemistry@2x.png",
        },
      ],
      none1: false,
      none2: false,
      none3: false,
      none4: false,
      none5: false,
      none6: false,
      none7: false,
      none8: false,
      none9: false,
      isLogin: false,
      nodata: false,
      nodata1: false,
      classData: [],
      teacherData: [],
      defaultClassImg:
        'this.src="' + require("../../assets/img/banji.png") + '"', // 图片损坏默认图
      userid: 1,
      article_id: 0,
      video_id: 0,
      jumpVisable: false,
      link: "",
    };
  },

  components: {},

  computed: {
    globalVaranthasInited() {
      return globalApi.gWebsiteSessionInfo.hasInited;
    },
  },
  watch: {
    $route() {
      this.getHttpPathAndSchoolId();
    },
    globalVaranthasInited: function () {
      this.init();
    },
  },
  created() {},

  methods: {
    goActicleInfo() {
      window.open(this.link);
      this.jumpVisable = false;
    },
    async getWebColumns() {
      let data = {
        s: "WebSchoolSpace.Column.GetWebColumns",
        weblevel: 1,
        incdisabled: true,
      };
      let res = await globalApi.post(data);

      let articleData = res.data.data.list;
      for (let i = 0; i < articleData.length; i++) {
        articleData[i].index = String(articleData[i].id);
      }
      articleData.forEach((row) => {
        if (row.fix_column_name == "school_article") {
          row.child_column.forEach((row1) => {
            if (row1.fix_column_name == "school_article_excellent") {
              this.article_id = row1.id;
            }
          });
        }
        if (row.fix_column_name == "school_video") {
          row.child_column.forEach((row1) => {
            if (row1.fix_column_name == "school_video_excellent") {
              this.video_id = row1.id;
            }
          });
        }
      });
    },
    //精品文章
    goto(index) {
      switch (index) {
        case 1:
          this.$router.push(
            "school_article_excellent?schoolid=" +
              this.$route.query.schoolid +
              "&id=" +
              this.article_id
          );
          break;
        case 2:
          this.$router.push(
            "school_video_excellent?schoolid=" +
              this.$route.query.schoolid +
              "&id=" +
              this.video_id
          );
          break;
        case 3:
          window.open(globalApi.GetWebHost("tiku"));
          break;
      }
    },
    init() {
      this.getHttpPathAndSchoolId();
      this.getWebColumns();
    },
    // 获取活动列表接口
    async searchActivity() {
      var data = {
        s: "WebEducationSpace.WorksShow.searchActivity",
        org_level: 2,
        page: 1,
        pagesize: 3,
        inc_parent_push: false,
        edu_id: this.$route.query.schoolid,
        contestant_status: 0,
        inc_living: true,
        inc_finished: true,
        rater_status: 0,
      };
      const res = await globalApi.post(data);
      this.schoolPresentation = res.data.data.list;
      this.none4 = this.schoolPresentation.length ? false : true;
    },
    // 动态根据地址给当前页面加上edu_id参数
    async getHttpPathAndSchoolId() {
      let fullVuePath = this.$route.fullPath; // 获取vue后断地址
      let fullPath = window.location.href; // 获取当前完整地址
      fullPath = fullPath.replace(fullVuePath, ""); // 去掉vue后断地址
      let paramQuery = this.$route.query;
      if (!paramQuery.schoolid) {
        this.$route.query.schoolid = globalApi.GetSchoolID();
      }
      this.searchActivity();
      this.getLoginInfo();
      this.getArticleData();
      this.getGroupType();
      this.getGroupList();
      this.getTypeList();
      this.getSection();
      this.SearchSchoolClass();
    },

    // 跳转班级空间
    toClassSpace(item) {
      globalApi.jumpPath(6, "home", "classid=" + item.classid);
    },
    // 跳转教师/学生空间
    toSpace(item) {
      globalApi.jumpPath(8, "home", "userid=" + item.userid); // 教师空间
    },

    // 获取登录数据
    async getLoginInfo() {
      this.isLogin = globalApi.IsLogIned();
      if (this.isLogin) {
        this.login_user_schoolid = globalApi.gWebsiteSessionInfo.userSchoolID;
        this.userid = globalApi.GetUserID();
      }
    },
    async getArticleData() {
      let data = {
        s: "WebSchoolSpace.HomePage.getHomePageInfo",
        weblevel: 1,
      };
      const response = await globalApi.post(data);
      const res = response.data.data;
      if (res.result == -1) {
        this.$message.error("服务器忙~请稍后再试!");
      }

      this.windowArticle = res.windowArticle;
      this.columnArticleFile = res.columnArticleFile;
      this.columnArticleNew = res.columnArticleNew;
      // this.schoolPresentation = res.schoolPresentation;
      this.schoolWeike = res.SchoolWeike;
      this.CourseVideo = res.CourseVideo;
      this.Webcast = res.Webcast;
      this.ModuleLinks = res.ModuleLinks;
      this.teacherList = res.schoolTeacher;
      this.classList = res.schoolClass;
      this.TeachingActivity = res.TeachingActivity;
      this.none1 = this.columnArticleNew.length ? false : true;
      this.none2 = this.columnArticleFile.length ? false : true;
      // this.none4 = this.schoolPresentation.length ? false : true;
      this.none5 = this.schoolWeike.length ? false : true;
      this.none6 = this.CourseVideo.length ? false : true;
      this.none7 = this.Webcast.length ? false : true;
      // this.none8 = this.classList.length ? false : true;
      this.none9 = this.teacherList.length ? false : true;
      this.isLoad = true;
    },

    // 获取专题工作类型
    async getGroupType() {
      let data = {
        s: "WebSchoolSpace.CollaborationGroup.getGroupTypeList",
        weblevel: 1,
      };
      const response = await globalApi.post(data);
      const res = response.data.data;
      if (res.result == -1) {
        this.$message.error("服务器忙~请稍后再试!");
      }
      if (res.result == 1) {
        this.groupType = res.list;
      } else {
      }
    },
    // 获取专题工作列表
    async getGroupList() {
      let data = {
        s: "WebSchoolSpace.HomePage.getCollaborationGroupList",
        weblevel: 1,
        type: this.groupTypeId,
        pagesize: 6,
      };
      const response = await globalApi.post(data);
      const res = response.data.data;
      if (res.result == -1) {
        this.$message.error("服务器忙~请稍后再试!");
      }

      if (res.result == 1) {
        this.groupList = res.list;
        this.none3 = this.groupList.length ? false : true;
      } else {
      }
    },
    // 获取班级接口
    async SearchSchoolClass() {
      const data = {
        s: "WebSchoolSpace.Zone.SearchSchoolClass",
        page: 1,
        page_size: 12,
      };
      const response = await globalApi.post(data);

      const res = response.data.data;
      if (res.result == -1) {
        this.$message.error("服务器忙~请稍后再试!");
      }
      this.classData = res.list;

      this.count = res.recordcount;
      this.nodata = this.count ? false : true;
    },

    handleClick1() {
      this.page = 1;
      const type_id = this.activeName1;
      this.groupTypeId = type_id;
      this.getGroupList();
    },

    // 选择专题工作类型
    selectGroup(val) {
      this.groupTypeId = val;
      this.getGroupList();
    },
    // 获取教学资源类型
    async getTypeList() {
      let data = {
        s: "WebSchoolSpace.TeachingArticle.getTypeList",
        weblevel: 1,
        article_type: 2,
      };
      const response = await globalApi.post(data);
      const res = response.data.data;
      if (res.result == -1) {
        this.$message.error("服务器忙~请稍后再试!");
      }
      if (res.result == 1) {
        this.ArticleType = res.list;
        this.getTeachingArticleList();
      } else {
      }
    },
    // 获取教学资源列表
    async getTeachingArticleList() {
      let data = {
        s: "WebSchoolSpace.HomePage.getTeachingArticleList",
        weblevel: 1,
        article_type: 2,
        type: this.ArticleId,
      };
      const response = await globalApi.post(data);
      const res = response.data.data;
      if (res.result == -1) {
        this.$message.error("服务器忙~请稍后再试!");
      }
      if (res.result == 1) {
        let tmp = res.list;
        tmp.forEach((row) => {
          let reg = new RegExp(">>", "g");
          row.title = row.title.replace(reg, ">");
        });
        this.ArticleList = tmp;
        this.none8 = this.ArticleList.length ? false : true;
      } else {
      }
    },
    // 切换教学资源类型
    handleClick() {
      this.page = 1;
      const type_id = this.activeName;
      this.ArticleId = type_id;
      this.getTeachingArticleList();
    },

    // 切换教学资源类型
    // changeArticleType(val) {
    //   this.ArticleId = val;
    //   this.getTeachingArticleList();
    // },
    // 获取学段
    async getSection() {
      let data = {
        s: "WebSchoolSpace.Common.getSection",
      };
      const response = await globalApi.post(data);
      const res = response.data.data;
      if (res.result == -1) {
        this.$message.error("服务器忙~请稍后再试!");
      }
      this.sectionList = res;
      this.sectionId = res[0].section_id;
      this.getSubject();
    },
    // 根据学段获取科目
    async getSubject() {
      let data = {
        s: "WebSchoolSpace.Common.getTikuSubject",
        sectionid: this.sectionId,
      };
      const response = await globalApi.post(data);
      const res = response.data.data;
      if (res.result == -1) {
        this.$message.error("服务器忙~请稍后再试!");
      }
      this.subjectList = res;
      for (let i in this.subjectList) {
        String((this.subjectList[i].imgUrl = this.subjectList[i].img));
      }
    },
    selectSection(sectionId) {
      this.sectionId = sectionId;
      this.getSubject();
    },
    // 跳转更多
    jumpToMore(filename, mode, id) {
      this.$router.push(
        filename +
          "?mode=" +
          mode +
          "&id=" +
          id +
          "&web_level=1" +
          "&schoolid=" +
          this.$route.query.schoolid
      );
    },

    // 跳转详情，无须验证权限
    jumpToInfo(pathId, filename, query) {
      globalApi.jumpPath(pathId, filename, query);
    },
    // 跳转详情，无须验证权限
    jumpToInfo2(pathId, filename, query, item) {
      if (item.mode != 5) {
        globalApi.jumpPath(pathId, filename, query);
      } else {
        this.getArticleInfo(item.id);
      }
    },
    async getArticleInfo(id) {
      let data = {
        s: "WebSchoolSpace.ColumnContent.getArticleInfo",
        articleid: id,
      };
      const response = await globalApi.post(data);
      const res = response.data.data;
      if (res.result == 1) {
        this.link = res.info.content;
        this.jumpVisable = true;
      } else {
        this.$message.error("没有查询到文章信息！");
      }
    },
    // 跳转详情,需要验证权限
    async jumpToInfo1(pathId, filename, query, auth) {
      //如果没登录且文章不公开
      if (auth != 1 && this.login_user_schoolid != this.$route.query.schoolid) {
        if (this.isLogin) {
          this.$message.error("你没有访问权限!");
          return;
        } else {
          // localStorage.setItem("objectPath", location.href);
          let fromurl = encodeURIComponent(location.href);
          location.href = globalApi.GetWebHost("login") + '?fromurl=' + fromurl;
          return;
        }
      }
      globalApi.jumpPath(pathId, filename, query);
    },
    // 轮播图跳转
    jumpPath(type, id) {
      if (type == 1) {
        globalApi.jumpPath(
          4,
          "school_activity_presentation_info",
          "a_id=" + id
        );
      }
      if (type == 2) {
        // 跳转到评课
      }
    },
    toInfoPage(item) {
      if (item.mode == 3) {
        var fileName = "videoInfo";
      } else if (item.mode == 5) {
        this.getArticleInfo(item.id);
        return;
      } else {
        var fileName = "articleInfo";
      }
      window.open(
        globalApi.GetWebHost("article") + fileName + "?articleid=" + item.id
      );
    },
    //跳转到缺省页面
    toInfoDefaultPage() {
      window.open(globalApi.GetWebHost("article") + "defaultInfo");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/scss/index_body.scss";
.container {
  width: 1200px;
  margin: 0 auto;
  position: relative;
}

.thisActive {
  color: #858585;
}
.icon-wrapper1 li div img {
  width: 100px;
  height: 100px;
}
.icon-wrapper1 li div {
  width: 100px;
  height: 100px;
}
.section-span {
  font-size: 12px;
}
.icon-wrapperrr li {
  margin-right: 40px;
}
.pkhd {
  position: relative;
  width: 100%;
  height: 100%;
}
.pkhd .title {
  font-size: 36px;
  position: absolute;
  width: 100%;
  top: 50px;
  text-align: center;
}
.pkhd .time {
  width: 100%;
  font-size: 26px;
  position: absolute;
  top: 150px;
  text-align: center;
}
.pkhd img {
  width: 100%;
  height: 100%;
}
.username em {
  padding: 2px 0;
}
.none-info {
  width: 100%;
  height: 300px;
  text-align: center;
  background: rgb(233, 233, 233);
  margin: 10px 0;
  font-size: 16px;
  font-weight: bold;
  color: rgb(160, 171, 186);
  img {
    margin-top: 40px;
  }
}
.none-info-1 {
  width: 100%;
  height: 230px;
  text-align: center;
  background: rgb(233, 233, 233);
  margin: 10px 0;
  font-size: 16px;
  font-weight: bold;
  color: rgb(160, 171, 186);
  img {
    margin-top: 20px;
  }
}
.top {
  margin-bottom: 10px;
}
.videoInfo {
  .title {
    cursor: pointer;
  }
}
.wrap .video .videoList {
  margin-right: 24px;
}
.classL {
  text-align: center;
}
</style>
<style lang="scss" scoped>
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.el-carousel--horizontal {
  overflow-y: hidden;
}
.el-carousel__container {
  height: 240px;
}
.fast {
  width: 110px;
  position: absolute;
  left: -165px;
  top: 200px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(216, 216, 226, 1);
  box-shadow: 0px 4px 10px 0px rgba(26, 91, 225, 0.3);
  border-radius: 8px;

  .fast-p1 {
    img {
      width: 110px;
    }
  }

  .fast-p2 {
    text-align: center;
    margin: 15px 0;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 24px;

    img {
      width: 80px;
      height: 80px;
      margin: 0 1px 15px 0;
      border-radius: 40px;
    }
    a {
      display: inline-block;
    }
    .fast-title {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 5.5rem;
    }
  }
}
.teachList {
  height: 500px;
}
.tlst {
  float: left;
  width: 118px;
  height: 152px;
  background: rgba(246, 249, 250, 1);
  border: 1px solid rgba(204, 209, 217, 1);
  border-radius: 8px;
  margin-right: 15px;
  margin-bottom: 15px;
}
.tlst:nth-child(9n) {
  margin-right: 0px !important;
}
.tlst img {
  display: block;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin: auto;
  margin-top: 24px;
}
.tlst p {
  text-align: center;
  line-height: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
<style  scoped>
.top-nav >>> .el-tabs__nav-wrap::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0px;
  background-color: #e4e7ed;
  z-index: 1;
}
.teaching_resource >>> .el-tabs__nav-wrap::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0px;
  background-color: #e4e7ed;
  z-index: 1;
}
.top-nav >>> .el-tabs__active-bar {
  height: 0px;
}
.teaching_resource >>> .el-tabs__active-bar {
  height: 0px;
}
.el-tabs__header {
  margin: 0;
}
.top-nav >>> .el-tabs__item {
  padding: 0 10px;
  font-size: 12px;
}
.teaching_resource >>> .el-tabs__item {
  padding: 0 10px;
  font-size: 12px;
}
.top-nav {
  width: 1000px;
}
.teaching_resource >>> .el-tabs--top {
  width: 92%;
}
</style>
<style>
.el-carousel__indicators--horizontal {
  width: 240px;
  text-align: center;
}
.group .group-item .group-info .title {
  line-height: 22px !important;
}
.video .videoList .videoInfo .title {
  line-height: 22px !important;
}
</style>
<style lang="scss">
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>